export const VUEX_CATEGORY_BROWSER_ACTIVE_CATEGORY_UPDATE = 'VUEX_CATEGORY_BROWSER_ACTIVE_CATEGORY_UPDATE'
export const VUEX_CATEGORY_BROWSER_UPDATE_ACTIONS = 'VUEX_CATEGORY_BROWSER_UPDATE_ACTIONS'
